import { Tooltip } from "antd";
import SquareInfoIcon from "assets/icons/SquareInfoIcon";
import styles from "./style.module.scss";

export interface PaginationInfoProps {
  range: [number, number];
  total: number;
  tooltip?: string;
}

export default function PaginationInfo({
  range,
  total,
  tooltip,
}: PaginationInfoProps) {
  return (
    <div className={styles.paginationInfo}>
      {tooltip && (
        <div>
          <Tooltip title={tooltip} placement="top" trigger={"hover"}>
            <div data-testid="pagination-info-icon">
              <SquareInfoIcon />
            </div>
          </Tooltip>
        </div>
      )}
      <div data-testid="pagination-info-text">{`${range[0]}-${range[1]} of ${total} items`}</div>
    </div>
  );
}
